export default __webpack_public_path__ + "static/media/rightArrow.d9e2dd57.svg";